import { Component, computed, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { AppStoreButtonsComponent } from '@core/navigation-ui';
import { TrackLinkDirective } from '@analytics/events';

import { HeroFieldService } from './../services/hero-field.service';
import type { Hero } from '../models/hero.model';

@Component({
  selector: 'wl-hero-button-group',
  standalone: true,
  imports: [
    CrntButtonAlt,
    GenericLinkDirective,
    AppStoreButtonsComponent,
    TrackLinkDirective,
  ],
  templateUrl: './hero-button-group.component.html',
  styleUrls: [
    './hero-button-group.component.ed.scss',
    './hero-button-group.component.essent.scss',
  ],
})
export class HeroButtonGroupComponent {
  readonly #fieldService = inject(FieldService);
  readonly #heroFieldService = inject(HeroFieldService);

  readonly hero = input.required<Partial<Hero>>();
  readonly inverted = input<boolean>(false);
  readonly large = input<boolean>(false);

  readonly primaryButton = computed(() => this.hero().primaryButton);
  readonly secondaryButton = computed(() => this.hero().secondaryButton);
  readonly appStoreButton = computed(() => this.hero().appStoreButton);
  readonly googlePlayButton = computed(() => this.hero().googlePlayButton);

  readonly showPrimaryButton = computed(() =>
    this.#fieldService.showLinkField(this.primaryButton())
  );
  readonly showSecondaryButton = computed(() =>
    this.#fieldService.showLinkField(this.secondaryButton())
  );

  readonly showButtonGroup = computed(() =>
    this.#heroFieldService.showButtonGroup(this.hero())
  );
}
